export default "__VITE_ASSET__BawhehSg__"